<template>
  <MonitorFinderApp/>
</template>

<script>
import MonitorFinderApp from './components/MonitorFinderApp.vue';

export default {
  name: 'App',
  components: {
    MonitorFinderApp
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
